export default {"src":"/_next/static/media/bell.b300fe59.svg","height":21,"width":18,"blurWidth":0,"blurHeight":0};